module.exports = __webpack_public_path__ + "fonts/Inter-200-cyrillic-ext11.47734ae.woff2";